import Swiper from 'swiper/js/swiper.min.js';

export default class GuideSwiper {
  constructor() {

    let swiper = undefined;
    let widthSize = window.innerWidth;
    let swiperEl = document.getElementsByClassName('swiper-container');
    let sliderOption = {
      slidesPerView: 'auto',
      spaceBetween: '20%',
      centeredSlides : true,
      loop: false,
      paginationClickable: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    }

    if (widthSize <= 768) {
      if(swiper == undefined) {
        swiper = new Swiper ('.swiper-container', sliderOption);
      }
    } else {}

    window.addEventListener( 'resize', function() {
      let widthSize = window.innerWidth;
      if (widthSize <= 768) {
        if(swiper == undefined) {
          swiper = new Swiper ('.swiper-container', sliderOption);
        }
      } else {
        if(swiper !== undefined) {
          for(let i = 0; i < swiperEl.length; i++) {
            swiper[i].destroy();
          }
          swiper = undefined;
        }
      }
    },false)

  }


}

